import React from 'react';
import type { IWidgetComponentProps } from '../../../IWidgetType';
import { useWidgetVisibility } from '../../../hooks/useWidgetVisibility';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { IColumnWidget } from './IColumnWidget';

export interface IColumnWidgetProps
  extends IWidgetComponentProps<IColumnWidget> {}

export function ColumnWidgetComponent(props: IColumnWidgetProps) {
  const options = getWidgetProps(props);
  const visible = useWidgetVisibility(props.widget, options);

  if (!visible) return null;

  return <>{props.children}</>;
}
